import {
  takeLatest, put, select,
} from 'redux-saga/effects';

import DocumentService from '../../../services/DocumentService';
import { apiCall } from '../../effects';
import { selectMediaViewer } from './selectors';
import {
  setOpenMediaViewer,
  setCurrentIndexMediaViewer,
  setCurrentDocumentPageMediaViewer,
  setMediaList,
  getDocumentPageListRequest,
  getDocumentPageListSuccess,
  getDocumentPageListFail,
  getDocumentDownloadUrlRequest,
  getDocumentDownloadUrlSuccess,
  getDocumentDownloadUrlFail,
} from './actions';
import { transformDocumentPage } from './utils';

function* processMediaByIndex(index: number) {
  // @ts-ignore
  const { mediaList } = yield select(selectMediaViewer);

  if (!mediaList) {
    return;
  }
  const media = mediaList[index];

  if (media) {
    switch (media.typeId) {
      case 3:
        yield put(getDocumentDownloadUrlRequest(media.id));
        break;

      case 4:
        yield put(getDocumentPageListRequest(media.id));
        break;

      default:
        break;
    }
  }
}

function* documentPageList({ payload }: ReturnType<typeof getDocumentPageListRequest>) {
  try {
    const pages = yield apiCall(DocumentService.getPageInfo, payload);
    yield put(getDocumentPageListSuccess(transformDocumentPage(pages)));
  } catch (e) {
    yield put(getDocumentPageListFail());
    console.error(e);
  }
}

function* documentDownloadUrl({ payload }: ReturnType<typeof getDocumentDownloadUrlRequest>) {
  try {
    const response = yield apiCall(DocumentService.downloadUrl, payload);
    yield put(getDocumentDownloadUrlSuccess({
      documentId: payload,
      signedUrl: response,
    }));
  } catch (e) {
    yield put(getDocumentDownloadUrlFail());
    console.error(e);
  }
}

function* open({ payload }: ReturnType<typeof setOpenMediaViewer>) {
  if (!payload) {
    yield put(setMediaList([]));
    yield put(setCurrentIndexMediaViewer(0));
    yield put(setCurrentDocumentPageMediaViewer(0));
  } else {
    // @ts-ignore
    const { currentIndex } = yield select(selectMediaViewer);
    yield processMediaByIndex(currentIndex || 0);
  }
}

function* changeMedia({ payload }: ReturnType<typeof setCurrentIndexMediaViewer>) {
  yield processMediaByIndex(payload);
}

export default [
  takeLatest(setOpenMediaViewer.type, open),
  takeLatest(setCurrentIndexMediaViewer.type, changeMedia),
  takeLatest(getDocumentPageListRequest.type, documentPageList),
  takeLatest(getDocumentDownloadUrlRequest.type, documentDownloadUrl),
];
